import {ITableResultData} from "@/containers/E4ImpactProjects/resources/config-schema"
import {
    baselineStructure,
    finalStructure,
    calculateTotalByKeyAndStructure,
    transformData
} from "../chart-calculations/increased-skills-chart-calculation";
import getValidSubmissions from "@/containers/E4ImpactMBA/helpers/getValidSubmissions";

const columns = [
    {
        headerName: 'Skill',
        field: 'skill',
        flex: 2
    },
    {
        headerName: 'Improved %',
        field: 'improved',
        flex: 1
    },
];

const calculatePercent = (baselineTotal: number, finalTotal: number): number =>
    baselineTotal ? (finalTotal * 100 / baselineTotal) - 100 : 0; 

export const increasedSkillsTableCalculation = (props: any): ITableResultData => {
    const {filteredBaseline, filteredFinal} = getValidSubmissions(
        props.baselineSubmissions,
        props.finalSubmissions
    );
    
    const rows = transformData.map(
        ({name, key}, index) => ({
            id: index,
            skill: name,
            improved: +calculatePercent(
                calculateTotalByKeyAndStructure(filteredBaseline, baselineStructure, key),
                calculateTotalByKeyAndStructure(filteredFinal, finalStructure, key)
            ).toFixed(2)
        })
    ).filter(({improved}) => improved);
    
    return {columns, rows}
}